import React from 'react';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import bem from '../../../../lib/bemUtils/bem';
import { SVG, SVGIcon } from '../../../../components/atoms/SVG';

export enum AppIconListItemModifier {
  SMALL = 'small',
}

type AppLibraryElementLinkContentProps = {
  modifier?: Modifier<AppIconListItemModifier>;
  src: string;
  icon?: SVGIcon;
};

export function AppIconListItem({ modifier, src, icon }: AppLibraryElementLinkContentProps) {
  return (
    <>
      {icon && (
        <span className="app-icon-list__svg">
          <SVG svgSpriteId={icon} />
        </span>
      )}
      <img
        className={bem('app-icon-list__img', modifier)}
        src={src || 'data:,'}
        /* Decision for empty alt please compare
         * "https://w3c.github.io/alt-techniques/with-pictures.html#icon-images-0"
         * § 3.15 Icon Images */
        alt=""
      />
    </>
  );
}
